<img
        class="business-logo"
        [src]="businessPictureUrl"
        (error)="onError()"
/>
